import { useState } from 'react';
import { Trans, t } from '@lingui/macro';
import { Tabs, TabNav, Tab, TabContent, TableColumnToggle, LoaderOverlay } from '@pocketlaw/tetris';
import { EmptyList } from './components/EmptyList';
import { TasksFilterMenu } from './components/TasksFilterMenu';
import { filterTasks } from '../../utils/filterTasks';
import { useTasks } from '../TasksProvider';
import { TasksTable } from '../TasksTable';
import { TasksIds } from '../types';
import { Wrapper } from './styled';
import { TabState } from './types';
const initialColumns = [
    {
        id: TasksIds.title,
        label: t({ message: 'Title', comment: 'Title column for task table toggle' }),
        active: true,
        disabled: true,
    },
    {
        id: TasksIds.status,
        label: t({ message: 'Status', comment: 'Status column for task table toggle' }),
        active: true,
        disabled: false,
    },
    {
        id: TasksIds.createdAt,
        label: t({ message: 'Created at', comment: 'Created at column for task table toggle' }),
        active: false,
        disabled: false,
    },
    {
        id: TasksIds.updatedAt,
        label: t({ message: 'Updated at', comment: 'updated at column for task table toggle' }),
        active: false,
        disabled: false,
    },
    {
        id: TasksIds.dueDate,
        label: t({ message: 'Due date', comment: 'Due date column for task table toggle' }),
        active: true,
        disabled: false,
    },
    {
        id: TasksIds.assignee,
        label: t({ message: 'Assignee', comment: 'Assignee column for task table toggle' }),
        active: true,
        disabled: false,
    },
];
export function TasksTableTabs() {
    const [columns, setColumns] = useState(initialColumns);
    const { activeFilter, setActiveFilter, tasks, setSortBy, sortBy } = useTasks();
    const { completedTasks, uncompletedTasks } = filterTasks(tasks.data);
    const emptyUncompletedTasks = uncompletedTasks.length < 1;
    const emptyCompletedTasks = completedTasks.length < 1;
    if (tasks.error) {
        return null;
    }
    return (<Tabs activeTab={activeFilter} onSelect={id => {
            const state = id;
            setActiveFilter(state);
        }}>
      <TabNav>
        <Tab id={TabState.UNCOMPLETED}>
          <Trans comment="Upcoming task tab">Upcoming</Trans>
        </Tab>
        <Tab id={TabState.COMPLETED}>
          <Trans comment="Completed task tab">Completed</Trans>
        </Tab>
      </TabNav>

      <LoaderOverlay enabled={tasks.loading}>
        <Wrapper>
          <TasksFilterMenu />
          <TableColumnToggle onChange={setColumns} headers={columns} size="small">
            {t({ message: 'Columns', comment: 'Toggle tasks column button title' })}
          </TableColumnToggle>
        </Wrapper>

        <TabContent tabId={TabState.UNCOMPLETED}>
          {emptyUncompletedTasks ? (<EmptyList />) : (<TasksTable tasks={uncompletedTasks} columns={columns} sort={sortBy} setSort={setSortBy}/>)}
        </TabContent>
        <TabContent tabId={TabState.COMPLETED}>
          {emptyCompletedTasks ? (<EmptyList completed/>) : (<TasksTable tasks={completedTasks} columns={columns} sort={sortBy} setSort={setSortBy}/>)}
        </TabContent>
      </LoaderOverlay>
    </Tabs>);
}
